import React from "react";
import { cn } from "./cn";

export default function Input({
  label,
  error,
  helperText,
  className,
  id,
  required = false,
  ...rest
}) {
  const inputId = id ?? `input-${Math.random().toString(36).slice(2, 8)}`;
  const helperId = `${inputId}-helper`;

  return (
    <div className={cn("w-full space-y-1.5", className)}>
      {label ? (
        <label htmlFor={inputId} className="block text-sm font-semibold text-ink-soft">
          {label}
          {required ? <span className="ml-1 text-red-600">*</span> : null}
        </label>
      ) : null}
      <input
        id={inputId}
        className={cn(
          "w-full rounded-xl border bg-white px-3.5 py-2.5 text-sm text-ink placeholder:text-ink-muted/70 shadow-sm transition-all",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/60",
          error ? "border-red-300 focus-visible:ring-red-500/40" : "border-arena/20"
        )}
        aria-invalid={Boolean(error)}
        aria-describedby={helperText || error ? helperId : undefined}
        required={required}
        {...rest}
      />
      {error ? (
        <p id={helperId} className="text-xs font-semibold text-red-700">
          {error}
        </p>
      ) : helperText ? (
        <p id={helperId} className="text-xs text-ink-muted">
          {helperText}
        </p>
      ) : null}
    </div>
  );
}
